
/* LA PINK - Smart Discount sticky cart price sync */
(() => {
  if (window.laPinkStickyBundlePriceLoaded) return;
  window.laPinkStickyBundlePriceLoaded = true;

  function syncStickyPrice() {
    const selected = document.querySelector(
      'smart-widget .sw-offer[aria-checked="true"]'
    );
    
    const stickyPrice = document.querySelector(
      '.sticky-cart .price-item--regular price-money bdi'
    );

    if (!selected) return;

    const match = selected.innerText.match(/₹\s*[\d,]+/);
    if (!match) return;

    const price = match[0].replace(/\s+/g, '');

    if (stickyPrice && stickyPrice.textContent.trim() !== price) {
        stickyPrice.textContent = price;
    }

  }

  function initialize() {
    syncStickyPrice();
    
    // Smart Discount may load after the Shopify theme.
    // Keep checking until its selected price is available.
    
    // Sync after Smart Discount selection changes
const widget = document.querySelector('smart-widget');

if (widget) {
  const observer = new MutationObserver(() => {
    syncStickyPrice();
  });

  observer.observe(widget, {
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-checked'],
    childList: true
  });
}

    document.addEventListener('click', event => {
      if (event.target.closest('smart-widget .sw-offer')) {
        setTimeout(syncStickyPrice, 150);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
